import { groupBy } from "lodash";
import api from "../config/api";

export const getPayments = async (data) => {
  const res = await api.post("jobPayments/getJobPayments", data);
  return res.data;
};

export const getPaymentByid = async (_id) => {
  const res = await api.get(`jobPayments/${_id}`);
  return res.data;
};

export const getPaymentsGroupedByJob = async (data) => {
  const res = await api.post("jobPayments/getJobPayments", data);
  return groupBy(res.data, (i) => i.job);
};

export const getPaymentsGroupedByContractInv = async (data) => {
  const res = await api.get(
    "jobPayments/getPaymentsGroupedByContractInv",
    data
  );
  return groupBy(res.data, (i) => i.contractInvoice);
};

export const getJobDetailsByInv = async (data) => {
  const res = await api.get("jobPayments/inv", data);
  return res.data;
};

export const getContDetailsByInv = async (data) => {
  const res = await api.get("jobPayments/contInv", data);
  return res.data;
};
